<template>
    <div>
        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <b-row>
                    <b-col md="6" lg="6">
                        <h5 class="font-weight-bold">Pemeriksaan Penunjang</h5>
                        <h6 class="mt-3">Uploaded file:</h6>
                        <div>
                            <template v-if="dataRM.pemeriksaan_penunjang.files !== 'null'">
                                <p v-for="items in datafile" :key="items.id">
                                    {{ items.name }}
                                    <font-awesome-icon class="align-middle"
                                        style="color:#3b3e66;padding:5px;font-size:1.7em;"
                                        @click="downloadImage(items, 'download')" icon="download" />
                                    <font-awesome-icon class="align-middle"
                                        style="color:#3b3e66;padding:5px;font-size:1.7em;"
                                        @click.prevent="downloadImage(items, 'preview')" icon="eye" />
                                </p>
                            </template>
                            <template v-else>
                                <span>-</span>
                            </template>
                        </div>
                    </b-col>
                    <b-col md="6" lg="6">
                        <h5 class="font-weight-bold">Surat Penunjang</h5>
                        <h6 class="mt-3">Uploaded file:</h6>
                        <template v-if="TransKlinikIDRiwayatRekamMedis">
                            <SuratPenunjangRiwayatRekamMedis :TransKlinikID="TransKlinikIDRiwayatRekamMedis"
                                :propSuratRujukBpjs="SuratRujukBpjs" />
                        </template>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12" lg="12">
                        <h6 class="mt-3 font-weight-bold">Deskripsi</h6>
                        <div v-html="this.dataRM.pemeriksaan_penunjang.notes || '-'"></div>
                        <template v-if="dataRM.pemeriksaan_penunjang.draw_path !== null">
                            <img :src="dataRM.pemeriksaan_penunjang.draw_path" class="img-fluid" alt="img" />
                        </template>
                    </b-col>
                </b-row>
            </div>
        </div>
        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <template
                    v-if="dataRM.transklinik.kategori_id == 2 || dataRM.transklinik.tgl_next_konsultasi !== '1970-01-01'">
                    <h5 class="font-weight-bold">Konsultasi Selanjutnya</h5>
                    <b-row class="mt-3">
                        <b-col md="12" lg="12" v-if="dataRM.transklinik.kategori_id == 2">
                            <div class="form-group row mb-header">
                                <label for="staticEmail" class="col-sm-3 col-form-label">Status Pulang</label>
                                <div class="col-sm-9 form-control-plaintext">
                                    : {{ setStatusPulang() }}
                                </div>
                            </div>
                        </b-col>
                        <template v-if="dataRM.bpjs_nmStatusPulang == 'Rujukan'">
                            <b-col md="12" lg="12" v-if="this.tacc.type == 'Y'">
                                <div class="form-group row mb-header">
                                    <label for="staticEmail" class="col-sm-3 col-form-label">Faktor Rujukan</label>
                                    <div class="col-sm-9 form-control-plaintext">
                                        : {{ tacc.faktor }}
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="12" lg="12" v-if="this.tacc.type == 'Y'">
                                <div class="form-group row mb-header">
                                    <label for="staticEmail" class="col-sm-3 col-form-label">Alasan</label>
                                    <div class="col-sm-9 form-control-plaintext">
                                        : {{ tacc.alasan }}
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="12" lg="12">
                                <div class="form-group row mb-header">
                                    <label for="staticEmail" class="col-sm-3 col-form-label">PPK Rujukan</label>
                                    <div class="col-sm-9 form-control-plaintext">
                                        : {{ datarujukan.faskes || '-' }}
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="12" lg="12">
                                <div class="form-group row mb-header">
                                    <label for="staticEmail" class="col-sm-3 col-form-label">Spesialis/Subspesialis</label>
                                    <div class="col-sm-9 form-control-plaintext">
                                        :
                                        <span v-if="datarujukan.spesialis && datarujukan.subspesialis">
                                            {{ datarujukan.spesialis || '-' }}{{ datarujukan.subspesialis ? ` /
                                            ${datarujukan.subspesialis}` : '' }}
                                        </span>
                                        <span v-else-if="datarujukan.spesialis">{{ datarujukan.spesialis || '-' }}</span>
                                        <span v-else-if="datarujukan.subspesialis">{{ datarujukan.subspesialis
                                            || '-' }}</span>
                                        <span v-else>-</span>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="12" lg="12">
                                <div class="form-group row mb-header">
                                    <label for="staticEmail" class="col-sm-3 col-form-label">Catatan</label>
                                    <div class="col-sm-9 form-control-plaintext">
                                        : {{ datarujukan.catatan || '-' }}
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="12" lg="12">
                                <div class="form-group row mb-header">
                                    <label for="staticEmail" class="col-sm-3 col-form-label">Tgl. Rencana
                                        Berkunjung</label>
                                    <div class="col-sm-9 form-control-plaintext">
                                        : {{ datarujukan.tglrujukan || '-' }}
                                    </div>
                                </div>
                            </b-col>
                        </template>

                        <b-col md="12" lg="12" v-if="dataRM.transklinik.tgl_next_konsultasi !== '1970-01-01'">
                            <div class="form-group row mb-header">
                                <label for="staticEmail" class="col-sm-3 col-form-label">Konsultasi Selanjutnya</label>
                                <div class="col-sm-9 form-control-plaintext">
                                    : {{ dateFormat(dataRM.transklinik.tgl_next_konsultasi) }}
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </template>
                <b-row class="mt-5">
                    <b-col md="12">
                        Last Modified: {{ dateLastModified(dataRM.updated_at) }}
                        <br>
                        by <strong>{{ dataRM.updated_by }}</strong>
                    </b-col>
                </b-row>
            </div>
        </div>
        <b-modal size="xl" ref="show-penunjang-doc" class="modal-backdrop" hide-footer scrollable title="Preview Dokumen">
            <div class="d-block text-center" style="height: 100%">
                <img :src="previewFile" class="img-fluid"
                    v-show="/jpg|jpeg|jfif|pjpeg|pjp|png|svg|webp|giff/.test(previewFile)" alt="preview-document">
                <iframe style="height:100%;width:100%" :src="previewFile" v-show="/pdf/.test(previewFile)" frameBorder="0"
                    scrolling="auto" height="100%" width="100%"></iframe>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import moment from "moment";
import { faFile, faDownload, faEye } from "@fortawesome/free-solid-svg-icons";
library.add(faFile, faDownload, faEye);
import rekamMedisMixin from "../mixins";

export default {
    name: "PemeriksaanSuratPenunjang",
    mixins: [rekamMedisMixin],
    props: ["dataRM", "dataRujukan"],
    components: {
        SuratPenunjangRiwayatRekamMedis: () =>
            import("../../../components/SuratPenunjang/SuratPenunjangRiwayatRekamMedis.vue"),
    },
    data() {
        return {
            datafile: null,
            previewFile: null,
            TransKlinikIDRiwayatRekamMedis: null,
            SuratRujukBpjs: null,
            datarujukan: {
                faskes: null,
                spesialis: null,
                subspesialis: null,
                catatan: null,
                tglrujukan: null,
            },
            tacc: {
                option: [],
                type: null,
                faktor: null,
                alasan: null,
            }
        }
    },
    computed: {
        ...mapGetters(["getKlinikId"]),
    },
    mounted() {
        this.buildData();
        this.buildDataRujukan();
    },
    watch: {
        dataRM(val) {
            this.buildData()
        },
        dataRujukan(val) {
            this.buildDataRujukan()
        }
    },
    methods: {
        async buildDataRujukan() {
            let rujukan = this.dataRujukan
            if (rujukan) {
                if (rujukan.ref_khusus) {
                    this.datarujukan = {
                        faskes: rujukan.ppkRujukan || null,
                        spesialis: rujukan.ref_khusus.nmKhusus || null,
                        subspesialis: rujukan.subSpesialis_khusus ? rujukan.subSpesialis_khusus.nmSubSpesialis : null,
                        catatan: rujukan.catatan || null,
                        tglrujukan: rujukan.tglRencanaBerkunjung || null,
                    }
                }
                if (rujukan.subSpesialis_spesialis) {
                    this.datarujukan = {
                        faskes: rujukan.ppkRujukan || null,
                        spesialis: null,
                        subspesialis: rujukan.subSpesialis_spesialis.nmSubSpesialis || null,
                        catatan: rujukan.catatan || null,
                        tglrujukan: rujukan.tglRencanaBerkunjung || null,
                    }
                }
            
                if (this.dataRM && this.dataRM.bpjs_health_data) {
                    this.tacc.alasan = this.dataRM.bpjs_health_data.alasan_tacc;

                    let kd_tacc = this.dataRM.bpjs_health_data.kd_tacc;
                    if (this.checkValueData(kd_tacc)) this.tacc.type = kd_tacc != '-1' ? 'Y' : 'T';
                    else {
                        this.tacc.type = null;
                        this.tacc.faktor = null;
                        this.tacc.alasan = null;
                    }

                    if (this.tacc.type == 'Y') {
                        if (this.tacc.option.length < 1) this.tacc.option = await this.fetchFaktorRujukan();
                        const data = this.tacc.option.find(v => v.value == kd_tacc);
                        if (data) this.tacc.faktor = data.label || '-';
                    }
                }
            }

        },
        buildData() {
            if (this.dataRM.pemeriksaan_penunjang.files) {
                this.datafile = JSON.parse(this.dataRM.pemeriksaan_penunjang.files);
            }

            this.$nextTick(() => {
                this.TransKlinikIDRiwayatRekamMedis = this.dataRM.transklinik_id;
                this.SuratRujukBpjs = JSON.parse(this.dataRM.transklinik.surat_rujuk_bpjs);
            })
        },
        async downloadImage(item, type) {
            if (type == 'download') {
                let fileName = this.getPureName(item.name);
                const a = document.createElement("a");
                a.href = await this.toDataURL(item.url);
                a.download = Object.values(fileName).join(".");
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            } else {
                this.previewFile = item.url;
                this.$refs['show-penunjang-doc'].show();
            }
        },
        getPureName(raw) {
            let extIndex = raw.lastIndexOf('_');
            let name = raw.slice(0, extIndex);
            return {
                name: name.replace(/[-_]/g, ' '),
                ext: raw.slice(extIndex + 1)
            }
        },
        toDataURL(url) {
            return fetch(url).then((response) => {
                return response.blob();
            }).then(blob => {
                return URL.createObjectURL(blob);
            });
        },
        dateFormat(d) {
            return moment(d).format("DD-MM-YYYY")
        },
        dateLastModified(d) {
            return moment(d).format('MMM DD, YYYY @ HH:mm')
        },
        setStatusPulang() {
            if (this.tacc.type == 'Y') return 'Rujukan dengan TACC';
            else if (this.tacc.type == 'T') return 'Rujukan tanpa TACC';
            return this.dataRM.bpjs_nmStatusPulang;
        },
    }
}
</script>

<style>
.mb-header {
    margin-bottom: -15px;
}
</style>